import type { ResearchSummaryDetail } from "./researchClient";

export function sortSummariesNewestFirst(summaries: ResearchSummaryDetail[]): ResearchSummaryDetail[] {
  return [...summaries].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
}
